import styled from '@emotion/styled';
import { useEffect } from 'react';

import logo from '@/images/did_logo.svg';
import presenterImage from '@/images/verifyEmailCover.png';
import { useAnalytics } from '@/services/analytics';

import SquareDots from './SquareDots';

const Page = styled.div`
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
`;

const LogoContainer = styled.div<{ src: string }>`
    align-self: flex-start;
    background-color: black;
    color: black;
    mask: url(${({ src }) => src}) no-repeat center;
    width: 10rem;
    height: 10rem;
    position: absolute;
    top: 2rem;
    left: 2rem;
`;

const Left = styled.div`
    display: flex;
    flex: 6;
    position: relative;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: radial-gradient(35.41% 62.94% at 2.84% 93.54%, rgba(137, 170, 255, 0.2) 0%, rgba(255, 255, 255, 0)) #f5faff;
`;

const Right = styled.div`
    display: flex;
    flex: 4;
    background-color: #a5a6f6;
    flex-direction: column;
`;

const Presenter = styled.img`
    width: 100%;
    height: 100%;
    background-color: transparent;
    object-fit: contain;
    object-position: bottom;
`;

const Title = styled.h1`
    font-weight: 700;
    font-size: 6rem;

    text-align: center;
    letter-spacing: -0.02em;

    color: #1b1c1e;

    margin-block: 0;
`;

const Description = styled.h2`
    font-weight: 500;
    font-size: 2rem;
    line-height: 24px;
    text-align: center;
    letter-spacing: -0.02em;

    color: #1b1c1e;
`;

type Props = {
    title: string;
    description: string;
};

const ErrorPage = ({ title, description }: Props) => {
    const mixpanel = useAnalytics();
    useEffect(() => {
        mixpanel?.track('reset-password', { event: 'view' });
    }, []);
    return (
        <Page>
            <Left>
                <LogoContainer src={logo} />
                <Title>{title}</Title>
                <Description>{description}</Description>
            </Left>
            <Right>
                <SquareDots />
                <Presenter src={presenterImage} />
            </Right>
        </Page>
    );
};

export default ErrorPage;
